import { ControlledCustomSelect } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { useIsMobile } from '@sravni/react-utils';

import { useDictionaries } from 'entities/creditForm';

export const AreaOfEmployment: FC<IFieldFactoryProps> = (props) => {
  const isMobile = useIsMobile();

  const { areasOfEmployment } = useDictionaries(['areasOfEmployment']);
  const { type, ...other } = props;

  return (
    <ControlledCustomSelect
      {...other}
      name={type}
      options={areasOfEmployment}
      withCrossIcon={false}
      mobile={isMobile}
    />
  );
};
